<p-dialog
  header="Rule Selection"
  [(visible)]="displayRuleSelection"
  [modal]="true"
  [responsive]="true"
  [style]="{width: '60vw'}"
  (onHide)="onCancel()">
    <div class="header">
        <h5 style="position: relative;">
            {{currentTitle}}
            <div class="btnBars p-mr-0" (click)="addQuestionnaireChannelRule()" style="float: right;">
              <i class="pi pi-plus"></i>
            </div>
            <div class="btnBars p-mr-0" (click)="QuestionnaireChannelRule()" style="float:
              right;" *ngIf="currentRuleLists.length >= 1">
              <i class="pi pi-minus"></i>
            </div>
        </h5>
    </div>
    <div class="card">
        <form #ruleForm="ngForm">
            <div *ngFor="let rule of currentRuleLists; let i= index;">
                <div class="p-field p-grid">
                <div class="p-col-12 p-lg-2">
                    <ng-container *ngIf="i > 0">
                    <p-dropdown
                        appendTo="body"
                        [options]="ruleChoices"
                        optionLabel="name"

                        [(ngModel)]="rule.filterChoice">
                    </p-dropdown>
                    <!-- <input
                        pInputText type="text"
                        [(ngModel)]="rule.filterChoice"
                        [disabled]="true"
                        [ngModelOptions]="{standalone: true}"> -->
                    </ng-container>
                </div>

                <div class="p-col-12 p-lg-4">
                    <p-dropdown
                    placeholder="Choose Field"
                    appendTo="body"
                    [options]="getCurrentRulefilters(i)"
                    scrollHeight="280px"
                    name="ruleFilter"
                    optionLabel="name"
                    [disabled]="isDisabled" dataKey="name"

                    [ngModelOptions]="{standalone: true}"
                    (onChange)="getValues(i,'add')" [(ngModel)]="rule.filter">
                    </p-dropdown>
                </div>

                <div class="p-col-12 p-lg-2">
                    <p-dropdown appendTo="body"
                    [options]="equals"
                    optionLabel="name"

                    [disabled]="isDisabled"
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="rule.expression">
                    </p-dropdown>
                </div>

                <div class="p-col-12 p-lg-4">

                    <div *ngIf="!rule?.filter">
                        <input pInputText type="text" [disabled]="true">
                    </div>

                    <div *ngIf="rule?.filter">
                        <ng-container *ngIf="rule.filter.field == 'country'">
                            <p-dropdown appendTo="body"
                                placeholder="Choose Value(s)"
                                [options]="rule.filterOptions"
                                optionLabel="businessName"
                                [(ngModel)]="rule.filterValue"
                                [disabled]="isDisabled"
                                [filter]="true"
                                filterBy="businessName"
                                name="countrySelect"
                                #countrySelect="ngModel"
                                (onChange)="onChangeValue(rule)"
                                required
                                [ngModelOptions]="{standalone: true}">
                                <ng-template let-dData pTemplate="item">
                                    <div>{{dData.businessName}} {{ dData?.count!=null?'('+dData.count+')':'' }}</div>
                                </ng-template>
                            </p-dropdown>
                            <div class="p-invalid" *ngIf="countrySelect.invalid && (countrySelect.dirty || countrySelect.touched || formSubmited)">Select {{ rule.filter?.name }}</div>
                        </ng-container>

                        <ng-container *ngIf="rule.filter.code !== 'country' && [formControlList.MultipleDropDownList, formControlList.DropDownList, formControlList.CheckBox, formControlList.RadioButton, formControlList.ToggleButton, formControlList.Rating].indexOf(rule.filter?.formControl.trim()) >= 0">
                            <p-multiSelect
                            placeholder="Choose Value(s)"
                            [options]="rule.filterOptions"
                            [optionGroupLabel]="rule?.groupLabel"
                            [optionGroupChildren]="rule?.groupChildren"
                            [group]="rule?.group"
                            [(ngModel)]="rule.filterValue"
                            [disabled]="isDisabled"
                            [ngModelOptions]="{standalone: true}"
                            (onChange)="onChangeValue(rule)"
                            dataKey="id"
                            optionLabel="businessName"
                            name="multiValue"
                            #multiValue="ngModel"
                            required
                            appendTo="body">
                            <ng-template let-dData pTemplate="item">
                                    <div>{{dData.businessName}} {{ dData?.count!=undefined?'('+(dData.count||0)+')':'' }}</div>
                            </ng-template>
                            </p-multiSelect>
                            <div class="p-invalid" *ngIf="multiValue.invalid && (multiValue.dirty || multiValue.touched || formSubmited)">Select {{ rule.filter?.name }}</div>
                        </ng-container>

                        <ng-container *ngIf="rule.filter?.formControl == formControlList.InputBox">
                            <input
                            pInputText
                            type="text"
                            [(ngModel)]="rule.filterValue"
                            [disabled]="isDisabled"
                            name="filter{{i}}" required>
                        </ng-container>

                        <ng-container *ngIf="rule.filter.formControl == formControlList.DatePicker">
                            <p-calendar
                            appendTo="body"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            placeholder="mm/dd/yyyy"
                            dateFormat="mm/dd/yy"
                            yearRange="1900:2100"
                            [ngModelOptions]="{standalone: true}"
                            [(ngModel)]="rule.filterValue">
                            </p-calendar>
                        </ng-container>

                    </div>

                </div>

                </div>
            </div>
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12">
                    <label>Notes</label>
                    <textarea
                    pInputTextarea
                    name="description"
                    [(ngModel)]="currentNote"
                    rows="3"
                    [disabled]="isDisabled">
                    </textarea>
                </div>
            </div>
        </form>
    </div>
    <p-footer>
      <button type="button" pButton (click)="onCancel()" label="Cancel" class="p-button-secondary"></button>
      <button type="button" pButton (click)="onSave()" label="Save"></button>
    </p-footer>
  </p-dialog>
